//// Application Packages
import React from 'react'

//// Application Slices

//// Application Components

//// Carbon Components

//// Carbon Icons

//// Static Constants

//////// Component
const DividerComponent = ({ text }) => {
    //////// Hooks

    //////// State

    //////// Slices

    //// Slice Data

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <div className="fldoh-divider-group">
                <h6 className="fldoh-divider-text">{text ? text : ''}</h6>
                <hr className="fldoh-divider" />
            </div>
        </>
    )
}

export default DividerComponent
